






































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AuthService from '@/services/auth';
import AppService from '@/services/app';

// --- Third Party imports ---

@Component
export default class CampaignCode extends Vue {
  promoCode: string = '';
  valid: boolean = false;
  clicked: boolean = false;
  rules = {
    required: (value: string) => !!value.trim() || '',
    promoCode: (value: string) => !/[a-zA-Z]/.test(value) || 'Promo code must only contain numbers',
  };

  // Functions
  
  async cancel() {
    if (this.$store.getters['users/loggedInUser'].isMomentumMember) {
      this.$router.push({ name: 'Momentum' });
    } else {
      this.$router.push({ name: 'Payment', params: { 
        discountAmount: '0', 
      }});
    }
  }

  async submit() {
    try {
      if (this.promoCode.trim().length > 0) {
        const promoCodeInt = parseInt(this.promoCode, 0);
        const response = await AuthService.checkPromoCode( { promoCode: promoCodeInt } );

        if (response.data.result === 'false') {
          // promo code has expired or does not exist
          AppService.errorHandler(response.data.message);
        } else {
          if (response.data.message === 'PAID') {
            // discount = 100%
            AppService.successHandler('Your test has been paid for.');
            this.$router.push({ name: 'Test' });

          } else if (response.data.message === 'DISCOUNT') {
            // discount < 100%
            AppService.successHandler('You have received a discount of ' + response.data.discount + '%');
            const discountAmount = parseInt(process.env.VUE_APP_TEST_COST, 10) * parseInt(response.data.discount, 10) * Math.pow(10, -2);
            //console.log(`CampaignCode.vue - 165 - discountAmount`, discountAmount);
            this.$router.push({ name: 'Payment', params: {
              discountPercentage: response.data.discount + '%',
              discountAmount: '' + discountAmount,
            }});
          }
        }
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
    }
  }
}
